module.exports = __webpack_public_path__ + "static/media/desert-mobile.c3f5ea11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/login/desert-mobile.jpg
// module id = 35
// module chunks = 0